// API 엔드포인트 유틸리티 함수들

/**
 * 파트너스테이션 API 기본 경로.
 * @see https://dev.api.rudalink.com/swagger-ui/index.html?urls.primaryName=PARTNER
 */
const API_BASE = '/partner';

export const createApiPath = {
  // 인증 — 로그인 외 전부 Bearer 토큰 필요
  auth: {
    login: () => `${API_BASE}/auth/login`,
    logout: () => `${API_BASE}/auth/logout`,
    me: () => `${API_BASE}/auth/me`,
  },

  // 05 사용자
  users: {
    list: () => `${API_BASE}/users`,
  },

  // 06 거래처 정보
  businessRelationships: {
    list: () => `${API_BASE}/business-relationships`,
  },

  // 07 처방 등록 현황 · 07-1 상세 패널
  prescriptionRegistrations: {
    list: () => `${API_BASE}/prescription-registrations`,
    summary: () => `${API_BASE}/prescription-registrations/summary`,
    months: () => `${API_BASE}/prescription-registrations/months`,
    detail: () => `${API_BASE}/prescription-registrations/detail`,
    /** 처방 등록 이미지 ZIP — POST 로 작업 생성, GET /{jobId} 로 상태 조회 */
    imageArchive: () => `${API_BASE}/prescription-registrations/images/archive`,
    imageArchiveJob: (jobId: string) =>
      `${API_BASE}/prescription-registrations/images/archive/${encodeURIComponent(jobId)}`,
    finalizedExcel: () =>
      `${API_BASE}/prescription-registrations/finalized/excel`,
  },

  // 목록 필터 선택지 (페이징 없음)
  filters: {
    users: () => `${API_BASE}/filters/users`,
    regions: () => `${API_BASE}/filters/regions`,
    pharmaCompanies: () => `${API_BASE}/filters/pharma-companies`,
  },
};
